import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useQuery } from "react-apollo-hooks";
import ReactMoment from "react-moment";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../Components/Panel/Panel";
import { CHARGEMANAGER_CONFIG_LIST_QUERY } from "../Queries";

// 담당으로 지정된 충전내역 설정 목록. 충전담당 로그인 시 첫 화면.
export default () => {
  const { data, loading } = useQuery(CHARGEMANAGER_CONFIG_LIST_QUERY, {
    fetchPolicy: "network-only",
  });

  if (loading) {
    return (
      <div className="panel-loader">
        <span className="spinner-small"></span>
      </div>
    );
  }

  const configs =
    (data && data.ChargeManagerChargeRequestConfigList) || [];

  return (
    <>
      <Helmet>
        <title>한밭페이 | 담당 충전내역</title>
      </Helmet>
      <h1 className="page-header">담당 충전내역</h1>
      <Panel>
        <PanelHeader noButton={true}>담당으로 지정된 충전내역 ({configs.length}건)</PanelHeader>
        <PanelBody>
          {configs.length === 0 ? (
            <div className="alert alert-warning m-b-0">
              담당으로 지정된 충전내역이 없습니다. 관리자에게 문의해주세요.
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped m-b-0">
                <thead>
                  <tr>
                    <th style={{ width: "60px" }}>번호</th>
                    <th>이름</th>
                    <th style={{ width: "160px" }}>등록일</th>
                    <th style={{ width: "120px" }}>관리</th>
                  </tr>
                </thead>
                <tbody>
                  {configs.map((config, index) => (
                    <tr key={config.id}>
                      <td>{configs.length - index}</td>
                      <td>{config.name}</td>
                      <td>
                        <ReactMoment format="YYYY-MM-DD">
                          {config.createdAt}
                        </ReactMoment>
                      </td>
                      <td>
                        <Link
                          to={`/chargeManager/configs/${config.id}/chargeRequests`}
                          className="btn btn-primary btn-xs"
                        >
                          충전내역 보기
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </PanelBody>
      </Panel>
    </>
  );
};
